import { toDatePickerFormat } from '../../util/time/millisecondOperations'
import { UserAttributeDef } from '../../types/ModelTypes'

export const getDateUserAttribute = (key: string, label: string): UserAttributeDef => ({
  type: 'Date',
  editable: false,
  label,
  name: key,
  displayFn: (actualValue: number | undefined) => (actualValue ? toDatePickerFormat(actualValue) : undefined),
  valueFn: (newValue: number | undefined) => (newValue ? new Date(newValue).valueOf() : undefined),
})

export const getDateUserAttributeFromStringNumber = (key: string, label: string): UserAttributeDef => ({
  type: 'Date',
  editable: false,
  label,
  name: key,
  displayFn: (actualValue: string | undefined) => (actualValue ? toDatePickerFormat(parseInt(actualValue)) : undefined),
  valueFn: (newValue: number | undefined) => (newValue ? new Date(newValue).valueOf().toString() : undefined),
})
